var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"triggers":['hover'],"aria-role":"list","position":"is-bottom-left"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('button',{staticClass:"button",class:_vm.status,attrs:{"slot":"trigger"},on:{"click":function($event){$event.stopPropagation();}},slot:"trigger"},[_vm._v("\n      "+_vm._s(_vm.status === "received"
          ? "Recebido"
          : _vm.status === "confirmed"
          ? "Confirmado"
          : _vm.status === "inPreparation"
          ? "Em preparação"
          : _vm.status === "ready"
          ? "Pronto"
          : _vm.status === "beingDelivered"
          ? "Em entrega"
          : _vm.status === "delivered"
          ? "Entregue"
          : _vm.status === "cancelled"
          ? "Cancelado"
          : "Sem status")+"\n    ")])]},proxy:true}])},[_c('b-dropdown-item',{attrs:{"aria-role":"listitem"}},[_c('button',{staticClass:"button is-info confirmed",attrs:{"disabled":[
          'confirmed',
          'inPreparation',
          'ready',
          'beingDelivered',
          'delivered',
          'cancelled'
        ].includes(_vm.status)},on:{"click":function($event){return _vm.changeOrderStatus('confirmed')}}},[_vm._v("\n      1 - Confirmar pedido\n    ")]),_c('br'),_c('br'),_c('button',{staticClass:"button is-info inPreparation",attrs:{"disabled":[
          'inPreparation',
          'ready',
          'beingDelivered',
          'delivered',
          'cancelled'
        ].includes(_vm.status)},on:{"click":function($event){return _vm.changeOrderStatus('inPreparation')}}},[_vm._v("\n      2 - Iniciar preparo\n    ")]),_c('br'),_c('br'),_c('button',{staticClass:"button is-info ready",attrs:{"disabled":['ready', 'beingDelivered', 'delivered', 'cancelled'].includes(_vm.status)},on:{"click":function($event){return _vm.changeOrderStatus('ready')}}},[_vm._v("\n      3 - Pedido pronto\n    ")]),_c('br'),_c('br'),_c('button',{staticClass:"button is-info delivered",attrs:{"disabled":['delivered', 'cancelled'].includes(_vm.status)},on:{"click":function($event){return _vm.changeOrderStatus('delivered')}}},[_vm._v("\n      4 - Pedido entregue\n    ")]),_c('br'),_c('hr'),_c('button',{staticClass:"button is-danger",attrs:{"disabled":['cancelled'].includes(_vm.status)},on:{"click":function($event){return _vm.changeOrderStatus('cancelled')}}},[_vm._v("\n      Pedido cancelado\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }